import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import moment from "moment";
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import _ from 'lodash';
import numeral from 'numeral';
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";
import {isFloat} from 'validator';

// Components
import DateInput from "../../../components/common/date-input";
import Select from "../../../components/common/virtualized-select";
import PurchaseOrderLinesTable from "../../../components/common/PurchaseOrderLinesTable";
import SerieSelector from "../../../components/common/SerieSelector";
import SelectProductDialog from "../../../components/dialogs/SelectProductDialog";

// Actions
import {createPurchaseOrder, cleanPurchaseOrders} from "../../../actions/purchase-orders";
import {getSuppliers, cleanSuppliers} from "../../../actions/suppliers";
import {getWarehouses, cleanWarehouses} from "../../../actions/warehouses";
import {getProducts, cleanProducts} from "../../../actions/products";
import {getSeries, cleanSeries} from "../../../actions/series";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

const queryOptions = {
    projection: 'order_code document_date expected_delivery_date supplier statistics.subtotal statistics.vat statistics.total status',
    populateRefs: [{
        field: 'supplier',
        projection: 'basic_info.name'
    }],
    calculateStatistics: 'purchase-orders'
};

class NewPurchaseOrder extends Component {
    constructor(props) {
        super(props);
        let supplier = -1;

        if (this.props.location.state && this.props.location.state.supplierId) {
            supplier = this.props.location.state.supplierId;
            this.props.getProducts({
                filters: {
                    'suppliers.supplier': supplier,
                    status: 'active'
                },
                projection: 'product_code name'
            });
        }

        this.state = {
            canSubmit: false,
            canNewLine: false,
            // Modal
            modalIsOpen: false,
            modalType: null,
            canSelectProduct: false,
            // series
            serieSelectedId: 'manual',
            serieSelectedValue: '',
            // object fields
            order_code: '',
            document_date: moment(),
            expected_delivery_date: moment(),
            supplier,
            supplier_order_code: '',
            comments: '',
            lines: List([]),
            // lines
            product: -1,
            warehouse: -1,
            amount: 0,
            price: 0,
            discount: 0,
            vat: 0,
            total: 0,
            // Statistics
            orderSubtotal: numeral(0).format(),
            orderVat: numeral(0).format(),
            orderTotal: numeral(0).format()
        };
    }
    componentDidMount() {
        this.props.getSuppliers({
            filters: { status: 'active' },
            projection: 'supplier_code basic_info.name',
            deleteVirtuals: true
        });
        this.props.getWarehouses({
            filters: { status: 'active' },
            projection: 'warehouse_code name'
        });
        this.props.getSeries({ document_type: 'purchase_order' });
    }
    componentDidUpdate(prevProps, prevState) {
        // Calculate Statistics
        if (this.state.lines !== prevState.lines) {
            let orderSubtotal = 0, orderVat = 0, orderTotal = 0;

            this.state.lines.forEach(line => {
                let subtotalCost, discount, subtotal, vat;

                subtotalCost = _.round((line.get('amount') * line.get('price')), 2);
                discount = _.round((subtotalCost * (line.get('discount') / 100)), 2);
                subtotal = subtotalCost - discount;
                vat = subtotal * (line.get('vat') / 100);

                orderSubtotal = orderSubtotal + subtotal;
                orderVat = orderVat + vat;
                orderTotal = orderTotal + line.get('total');

            });

            this.setState({
                orderSubtotal: numeral(orderSubtotal).format(),
                orderVat: numeral(orderVat).format(),
                orderTotal: numeral(orderTotal).format()
            });
        }

        // Selected Serie
        if (this.props.series.size > 0 && this.props.series !== prevProps.series) {
            let serieSelectedId = 'manual', serieSelectedValue = '';

            this.props.series.forEach(serie => {
                if (serie.get('is_default')) {
                    serieSelectedId = serie.get('_id');
                    serieSelectedValue = serie.get('prefix') + _.padStart((serie.get('last_count') + 1), serie.get('number_length'), '0')
                }
            });
            this.setState({ serieSelectedId, serieSelectedValue })
        }

        // Redirect when created
        if (this.props.purchaseOrders !== prevProps.purchaseOrders) {
            if (this.props.purchaseOrders.get(0)) {
                this.props.history.push('/compras/pedidos');
            }
        }
    }
    componentWillUnmount() {
        this.props.cleanPurchaseOrders();
        this.props.cleanProducts();
        this.props.cleanWarehouses();
        this.props.cleanSuppliers();
        this.props.cleanSeries();
    }

    deleteLine = index => {
        this.setState({
            lines: this.state.lines.delete(index)
        });
    };
    onChangeSerieSelected = (serieSelectedId, serieSelectedValue) => {
        this.setState({
            serieSelectedId,
            serieSelectedValue,
            order_code: ''
        }, this.validatePurchaseOrder);
    };
    validateLine = () => {
        if (
            this.state.product !== -1 &&
            this.state.warehouse !== -1 &&
            this.state.amount !== 0
        ) {
            this.setState({ canNewLine: true }, this.validatePurchaseOrder);
        } else {
            this.setState({ canNewLine: false }, this.validatePurchaseOrder);
        }
    };
    validatePurchaseOrder = () => {
        if (
            (this.state.serieSelectedId !== 'manual' || this.state.order_code !== '') &&
            this.state.document_date.isValid() &&
            this.state.supplier !== '' &&
            this.state.supplier_order_code !== ''
        ) {
            this.setState({ canSubmit: true });
        } else {
            this.setState({ canSubmit: false });
        }
    };
    handleCreateClick = () => {
        let lines = new List([]);

        this.state.lines.forEach(line => {
            lines = lines.insert(lines.size, line
                .set('product', line.getIn(['product', '_id']))
                .set('warehouse', line.getIn(['warehouse', '_id']))
                .delete('_id')
                .delete('total')
            )
        });

        this.props.createPurchaseOrder({
            serieSelectedId: this.state.serieSelectedId,
            order_code: this.state.order_code,
            document_date: this.state.document_date,
            expected_delivery_date: this.state.expected_delivery_date,
            supplier: this.state.supplier,
            supplier_order_code: this.state.supplier_order_code,
            comments: this.state.comments,
            lines,
        }, queryOptions);
        // this.props.history.push('/compras/pedidos');
    };

    onCanSelectProduct = (canSelectProduct) => {
        this.setState({
            canSelectProduct
        });
    };
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    setProductState = (product) => {
      this.setState({
          product
      });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'selectProductDialog':
                    modal = {
                        width: 'medium',
                        title: 'Seleccionar producto',
                        body: (
                            <SelectProductDialog
                                onRef={ref => (this.child = ref)}
                                onCanSelectProduct={this.onCanSelectProduct}
                                onCloseModal={this.closeModal}
                                products={this.props.products}
                                setProductState={this.setProductState}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="select"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSelectProduct}
                                    onClick={ () => this.child.onSelectButtonClick() }
                                >
                                    {'Seleccionar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/compras/pedidos">Pedidos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Pedido</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.push('/compras/pedidos') }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ this.handleCreateClick }
                                disabled={!this.state.canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código de pedido de compras *</label>
                                                <div className="row">
                                                    <div className="col" style={{ paddingRight: 0 }} >
                                                        { this.state.serieSelectedId === 'manual'
                                                            ? <input
                                                                className="form-control"
                                                                type="text"
                                                                value={this.state.order_code}
                                                                onChange={ (event) => {
                                                                    this.setState({
                                                                        order_code: event.target.value
                                                                    }, this.validatePurchaseOrder);
                                                                }}
                                                            />
                                                            : <input
                                                                className="form-control"
                                                                type="text"
                                                                value={ this.state.serieSelectedValue }
                                                                disabled={true}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                                        { this.props.series.size > 0
                                                            ? <SerieSelector
                                                                series={this.props.series}
                                                                serieSelectedId={this.state.serieSelectedId}
                                                                onChangeSerieSelected={this.onChangeSerieSelected}
                                                            />
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha pedido *</label>
                                                <DateInput
                                                    onChange={(selectedDate) => {
                                                        this.setState({
                                                            document_date: selectedDate
                                                        }, this.validatePurchaseOrder);
                                                    }}
                                                    value={this.state.document_date}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha prevista de entrega</label>
                                                <DateInput
                                                    onChange={(selectedDate) => {
                                                        this.setState({
                                                            expected_delivery_date: selectedDate
                                                        });
                                                    }}
                                                    value={this.state.expected_delivery_date}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-6">
                                            <label>Proveedor *</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.props.suppliers.toJS()}
                                                value={this.state.supplier}
                                                labelKey="select"
                                                valueKey="_id"
                                                matchProp="select"
                                                multi={false}
                                                searchable={true}
                                                clearable={false}
                                                onChange={(supplier) => {
                                                    if (supplier && supplier._id !== this.state.supplier) {
                                                        this.props.getProducts({
                                                            filters: {
                                                                'suppliers.supplier': supplier._id,
                                                                status: 'active'
                                                            },
                                                            projection: 'product_code name'
                                                        });
                                                        this.setState({
                                                            supplier: supplier._id,
                                                            supplier_order_code: '',
                                                            comments: '',
                                                            lines: List([]),
                                                            product: -1,
                                                            warehouse: -1,
                                                            amount: 0,
                                                            price: 0,
                                                            discount: 0,
                                                            vat: 0,
                                                            total: 0,
                                                        }, this.validatePurchaseOrder);
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>Código de pedido del proveedor *</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.supplier_order_code}
                                                onChange={ (event) => {
                                                    this.setState({
                                                        supplier_order_code: event.target.value
                                                    }, this.validatePurchaseOrder);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-12">
                                            <label>Comentarios</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.comments}
                                                onChange={ (event) => {
                                                    this.setState({
                                                        comments: event.target.value
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <h4>Lineas de pedido</h4>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-3">
                                            <label>Producto *</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.props.products.toJS()}
                                                value={this.state.product}
                                                labelKey="select"
                                                valueKey="_id"
                                                matchProp="select"
                                                multi={false}
                                                searchable={true}
                                                clearable={false}
                                                onChange={(product) => {
                                                    if (product) {
                                                        this.setState({
                                                            product: product._id
                                                        }, this.validateLine)
                                                    }
                                                }}
                                                disabled={this.state.supplier === -1}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <label>Almacén destino *</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.props.warehouses.toJS()}
                                                value={this.state.warehouse}
                                                labelKey="select"
                                                valueKey="_id"
                                                matchProp="select"
                                                multi={false}
                                                searchable={true}
                                                clearable={false}
                                                onChange={(warehouse) => {
                                                    if (warehouse) {
                                                        this.setState({
                                                            warehouse: warehouse._id
                                                        }, this.validateLine);
                                                    }
                                                }}
                                                disabled={this.state.supplier === -1}
                                            />
                                        </div>
                                        <div className="col">
                                            <label>Cantidad</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.amount}
                                                onChange={ (event) => {
                                                    let amount = event.target.value;
                                                    if (amount === '') amount = '0';
                                                    if (isFloat(amount)) {
                                                        let subtotalCost, discount, subtotal, vat, total;

                                                        subtotalCost = _.round(amount, 5) * _.round(this.state.price, 5);
                                                        discount = subtotalCost * (this.state.discount / 100);
                                                        subtotal = subtotalCost - discount;
                                                        vat = subtotal * (this.state.vat / 100);
                                                        total = subtotal + vat;

                                                        this.setState({
                                                            amount,
                                                            total: _.round(total, 2)
                                                        }, this.validateLine);
                                                    }
                                                }}
                                                disabled={this.state.product === -1}
                                            />
                                        </div>
                                        <div className="col">
                                            <label>Precio</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.price}
                                                onChange={ (event) => {
                                                    let price = event.target.value;
                                                    let subtotalCost, discount, subtotal, vat, total;

                                                    if (price === '') price = '0';
                                                    if (isFloat(price)) {
                                                        subtotalCost = _.round(this.state.amount, 5) * _.round(price,5);
                                                        discount = subtotalCost * (this.state.discount / 100);
                                                        subtotal = subtotalCost - discount;
                                                        vat = subtotal * (this.state.vat / 100);
                                                        total = subtotal + vat;

                                                        this.setState({
                                                            price,
                                                            total: _.round(total, 2)
                                                        });
                                                    }
                                                }}
                                                disabled={this.state.product === -1}
                                            />
                                        </div>
                                        <div className="col">
                                            <label>Descuento (%)</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.discount}
                                                onChange={ (event) => {
                                                    let discount = event.target.value;
                                                    let subtotalCost, discountLine, subtotal, vat, total;

                                                    if (discount === '') discount = '0';
                                                    if (isFloat(discount) && discount <= 100) {
                                                        subtotalCost = _.round(this.state.amount, 5) * _.round(this.state.price, 5);
                                                        discountLine = subtotalCost * (discount / 100);
                                                        subtotal = subtotalCost - discountLine;
                                                        vat = subtotal * (this.state.vat / 100);
                                                        total = subtotal + vat;

                                                        this.setState({
                                                            discount,
                                                            total: _.round(total, 2)
                                                        });
                                                    }
                                                }}
                                                disabled={this.state.product === -1}
                                            />
                                        </div>
                                        <div className="col">
                                            <label>IVA (%)</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.vat}
                                                onChange={ (event) => {
                                                    let vat = event.target.value;
                                                    let subtotalCost, discount, subtotal, vatLine, total;

                                                    if (vat === '') vat = '0';
                                                    if (isFloat(vat) && vat <= 100) {
                                                        subtotalCost = _.round(this.state.amount, 5) * _.round(this.state.price, 5);
                                                        discount = subtotalCost * (this.state.discount / 100);
                                                        subtotal = subtotalCost - discount;
                                                        vatLine = subtotal * (vat / 100);
                                                        total = subtotal + vatLine;

                                                        this.setState({
                                                            vat,
                                                            total: _.round(total, 2)
                                                        });
                                                    }
                                                }}
                                                disabled={this.state.product === -1}
                                            />
                                        </div>
                                        <div className="col">
                                            <label>Total</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.total}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-auto" style={{ paddingTop: 23 }} >
                                            <button
                                                className="btn btn-custom"
                                                disabled={!this.state.canNewLine}
                                                onClick={() => {
                                                    let lines = new List(this.state.lines);
                                                    let index = this.props.products.findIndex( product => product.get('_id') === this.state.product );
                                                    const product = this.props.products.get(index);
                                                    index = this.props.warehouses.findIndex( warehouse => warehouse.get('_id') === this.state.warehouse );
                                                    const warehouse = this.props.warehouses.get(index);

                                                    lines = lines.insert(lines.size, Map({
                                                        _id: lines.size,
                                                        product,
                                                        warehouse,
                                                        amount: _.round(this.state.amount, 5),
                                                        price: _.round(this.state.price, 5),
                                                        discount: _.round(this.state.discount, 2),
                                                        vat: _.round(this.state.vat, 2),
                                                        total: this.state.total
                                                    }));

                                                    this.setState({
                                                        lines,
                                                        product: -1,
                                                        warehouse: -1,
                                                        amount: 0,
                                                        price: 0,
                                                        discount: 0,
                                                        vat: 0,
                                                        total: 0,
                                                        canNewLine: false
                                                    });
                                                }}
                                            >
                                                <Icon
                                                    style={{ margin: '2px 0px' }}
                                                    icon="plus" title="Añadir"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <PurchaseOrderLinesTable
                                        editMode={true}
                                        purchaseOrderLines={this.state.lines}
                                        deleteLine={this.deleteLine}
                                    />
                                    <div className="row stats-zone d-flex justify-content-end" style={{  }} >
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.orderSubtotal }</span>
                                            <span>Subtotal</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.orderVat }</span>
                                            <span>IVA</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.orderTotal }</span>
                                            <span>Total</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const suppliersReducer = state.suppliers;
    const warehousesReducer = state.warehouses;
    const productsReducer = state.products;
    const seriesReducer = state.series;

    const purchaseOrdersReducer = state.purchaseOrders;
    const purchaseOrders = purchaseOrdersReducer.get('payload') || List([]);

    // Suppliers
    let suppliersList = suppliersReducer.get('payload') || List([]);
    let suppliers = List([]);

    if (!(suppliersList instanceof List)) {
        suppliersList = List([]);
    }

    suppliers = suppliers.insert(0, Map({
        _id: -1,
        select: 'Selecciona un proveedor'
    }));
    suppliersList.map( supplier => {
        return suppliers = suppliers.insert(suppliers.size,
            supplier.set('select', `[${supplier.get('supplier_code')}] ${supplier.getIn(['basic_info','name'])}`)
        )
    });

    // Warehouses
    let warehouses = warehousesReducer.get('payload') || List([]);

    if (warehouses.size > 0) {
        warehouses = warehouses.map(warehouse => warehouse.set('select', `[${warehouse.get('warehouse_code')}] ${warehouse.get('name')}`));
    }

    warehouses = warehouses.insert(0, Map({
        _id: -1,
        select: 'Selecciona un almacén'
    }));

    // Products
    let products = productsReducer.get('payload') || List([]);

    if (products.size > 0) {
        products = products.map(product => product.set('select', `[${product.get('product_code')}] ${product.get('name')}`));
    }

    products = products.insert(0, Map({
        _id: -1,
        select: 'Selecciona un producto'
    }));

    // Series
    let series = seriesReducer.get('payload') || List([]);

    return {
        purchaseOrders,
        suppliers,
        warehouses,
        products,
        series
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSuppliers: (query) => dispatch(getSuppliers(query)),
        getWarehouses: (query) => dispatch(getWarehouses(query)),
        getProducts: (query) => dispatch(getProducts(query)),
        getSeries: (query) => dispatch(getSeries(query)),
        createPurchaseOrder: (purchaseOrder, options) => dispatch(createPurchaseOrder(purchaseOrder, options)),
        cleanPurchaseOrders: () => dispatch(cleanPurchaseOrders()),
        cleanSuppliers: () => dispatch(cleanSuppliers()),
        cleanWarehouses: () => dispatch(cleanWarehouses()),
        cleanProducts: () => dispatch(cleanProducts()),
        cleanSeries: () => dispatch(cleanSeries())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPurchaseOrder);



// WEBPACK FOOTER //
// ./src/containers/purchases/orders/NewPurchaseOrder.js